import { Decimal } from 'decimal.js'
import { TokenMetadataItem } from 'types/token'
import { POPULAR_SWAP_TOKENS } from './constants'

export const validateTradeForm = (amount: Decimal, max: string) => {
  if (amount.gt(new Decimal(max))) {
    return 'Insufficient funds'
  }
  return
}

export const getQuotePriority = (token: TokenMetadataItem): number => {
  if (!token) return -1
  switch (token.symbol) {
    case 'USDC':
      return 3
    case 'USDT':
      return 2
    case 'SOL':
      return 1
    default:
      return 0
  }
}

// determine which token should be quote based on priority
export const determineQuoteToken = (
  token1: TokenMetadataItem,
  token2: TokenMetadataItem,
): {
  quoteToken: TokenMetadataItem
  baseToken: TokenMetadataItem
} => {
  const token1IsPopular = POPULAR_SWAP_TOKENS.some(
    (t) => t.mint === token1.mint,
  )
  const token2IsPopular = POPULAR_SWAP_TOKENS.some(
    (t) => t.mint === token2.mint,
  )

  // if only one token is in POPULAR_SWAP_TOKENS, it should be the quote
  if (token1IsPopular && !token2IsPopular) {
    return { quoteToken: token1, baseToken: token2 }
  }
  if (!token1IsPopular && token2IsPopular) {
    return { quoteToken: token2, baseToken: token1 }
  }
  // if both or neither are popular, use priority system
  const token1Priority = getQuotePriority(token1)
  const token2Priority = getQuotePriority(token2)

  return token1Priority >= token2Priority
    ? { quoteToken: token1, baseToken: token2 }
    : { quoteToken: token2, baseToken: token1 }
}
